import callCmAPI from 'services/helpers/call-cm-api'

export type AuditLogEntry = {
  id: number
  user_id: number
  user_email: string | null
  user_name: string | null
  customer_id: number
  reason: string
  timestamp: string
  viewed_company: {
    company_name: string
    local_id: string
  }
  cvr: string
}

export type AuditLogPagination = {
  page: number
  page_size: number
  total_records: number
  total_pages: number
}

export type AuditLogResponse = {
  data: AuditLogEntry[]
  pagination: AuditLogPagination
}

export type AuditLogSortField =
  | 'timestamp'
  | 'reason'
  | 'customer_id'
  | 'user_id'
  | 'user_name'

export type AuditLogParams = {
  page?: number
  page_size?: number
  search?: string
  reason?: string
  date_from?: string
  date_to?: string
  sort_by?: AuditLogSortField
  sort_order?: 'asc' | 'desc'
}

export const getAuditLogs = (
  customerId: number | string,
  params: AuditLogParams = {},
): Promise<AuditLogResponse> => {
  const queryParams = new URLSearchParams()

  if (params.page) queryParams.append('page', params.page.toString())
  if (params.page_size)
    queryParams.append('page_size', params.page_size.toString())
  if (params.search) queryParams.append('search', params.search)
  if (params.reason) queryParams.append('reason', params.reason)
  if (params.date_from) queryParams.append('date_from', params.date_from)
  if (params.date_to) queryParams.append('date_to', params.date_to)
  if (params.sort_by) queryParams.append('sort_by', params.sort_by)
  if (params.sort_order) queryParams.append('sort_order', params.sort_order)

  const queryString = queryParams.toString()
  const url = `/customer/beneficial_owner/audit_log/${customerId}${
    queryString ? `?${queryString}` : ''
  }`

  return callCmAPI(url, {
    method: 'get',
  })
    .then(({ data: { data } }) => data)
    .catch((err) => {
      return Promise.reject(err.response?.data?.error || err)
    })
}
